import { he } from "date-fns/locale";

function CheckIcon(props) {
  const { 
    className, 
    color= '#727580', 
    height = 11, 
    width = 16,
    strokeWidth 
  } = props

  const stroke = strokeWidth ? {strokeWidth, stroke: color} : {};

  return (
    <svg 
      height={height}
      width={width}
      className={className}
      viewBox="0 0 16 11" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M5.54976 9.88075L14.3518 1.07875C14.4491 0.981419 14.5638 0.929502 14.696 0.923002C14.828 0.916668 14.9491 0.968586 15.0593 1.07875C15.1696 1.18909 15.2248 1.308 15.2248 1.4355C15.2248 1.56317 15.1696 1.68209 15.0593 1.79225L6.11526 10.7423C5.9536 10.9038 5.7651 10.9845 5.54976 10.9845C5.33443 10.9845 5.14593 10.9038 4.98426 10.7423L0.934265 6.69225C0.836931 6.59492 0.786015 6.47925 0.781515 6.34525C0.777015 6.21125 0.829931 6.08909 0.940264 5.97875C1.05043 5.86859 1.16926 5.8135 1.29676 5.8135C1.42443 5.8135 1.54335 5.86859 1.65351 5.97875L5.54976 9.88075Z" 
        fill={color}
        {...stroke}
      />
    </svg>

  );
}

export { CheckIcon };
